import { render, staticRenderFns } from "./PolicyEdit.vue?vue&type=template&id=171555ed&"
import script from "./PolicyEdit.vue?vue&type=script&lang=js&"
export * from "./PolicyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports